"use strict";
/*
// <copyright file="ReactGridUI.tsx" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var $dyn;
(function ($dyn) {
    var reactGrid;
    (function (reactGrid) {
        reactGrid.LoadedControlResources = {};
        function areResourcesLoading() {
            return Object.getOwnPropertyNames($dyn.reactGrid.LoadedControlResources)
                .some(function (resource) {
                return $dyn.reactGrid.LoadedControlResources[resource].state() === "pending";
            });
        }
        reactGrid.areResourcesLoading = areResourcesLoading;
        /**
         * Iterates over each column in this.props.ColumnInfo and loads any
         * additional resources specified by each column's ReactResource property.
         * @param columns The columns to load resources for
         * @param callback A callback to call when all resources have been loaded.
         * @returns The number of resources that are loading
         */
        function loadControlResources(columns, callback) {
            return columns.filter(function (col) {
                var reactResource = $dyn.value(col.ReactResource);
                if (!reactResource) {
                    // The control does not have a react resource to load.
                    return false;
                }
                else if ($dyn.reactGrid.LoadedControlResources[reactResource] === undefined) {
                    // The control resource has not yet been loaded, so start loading it.
                    $dyn.reactGrid.LoadedControlResources[reactResource] = $dyn.getResourceManager(reactResource).promise();
                    $dyn.reactGrid.LoadedControlResources[reactResource].done(function () {
                        // If there are no more loading resources, update columns.
                        if (callback && !$dyn.reactGrid.areResourcesLoading()) {
                            callback();
                        }
                    });
                    return true;
                }
                else if ($dyn.reactGrid.LoadedControlResources[reactResource].state() === "pending") {
                    // The control resource has started loading but isn't finished.
                    $dyn.reactGrid.LoadedControlResources[reactResource].done(function () {
                        // If there are no more loading resources, update columns.
                        if (callback && !$dyn.reactGrid.areResourcesLoading()) {
                            callback();
                        }
                    });
                    return true;
                }
                else {
                    return false;
                }
            }).length;
        }
        reactGrid.loadControlResources = loadControlResources;
        var UI;
        (function (UI) {
            var ReactGrid = /** @class */ (function (_super) {
                __extends(ReactGrid, _super);
                function ReactGrid(props) {
                    var _this = _super.call(this, props) || this;
                    _this.onRequestAddTotalColumn = function (columnName, complete) {
                        _this.props.OnRequestAddTotalColumn && _this.props.OnRequestAddTotalColumn(columnName, complete, { performRender: true });
                    };
                    _this.state = {
                        columns: null,
                        columnsVersion: 0,
                        isLoadingGrid: !$dyn.value($dyn.util.controlLibraryResourcesLoaded),
                        isLoadingResources: false,
                    };
                    return _this;
                }
                ReactGrid.prototype.componentWillMount = function () {
                    if (!this.state.isLoadingGrid) {
                        var newState = this.updateColumns(this.props);
                        this.setState(newState);
                    }
                };
                ReactGrid.prototype.componentWillReceiveProps = function (nextProps) {
                    if (!this.state.isLoadingGrid &&
                        (nextProps.ColumnInfo !== this.props.ColumnInfo ||
                            nextProps.DefaultControl !== this.props.DefaultControl ||
                            nextProps.ForceNavigationAction !== this.props.ForceNavigationAction ||
                            nextProps.NavigationEnabled !== this.props.NavigationEnabled ||
                            nextProps.NavigationAction !== this.props.NavigationAction)) {
                        var newState = this.updateColumns(nextProps);
                        this.setState(newState);
                    }
                };
                ReactGrid.prototype.componentDidMount = function () {
                    var _this = this;
                    this.props.PostRender();
                    if (this.state.isLoadingGrid) {
                        this.resourcesObserver = $dyn.observe($dyn.util.controlLibraryResourcesLoaded, function (value) {
                            if (value) {
                                var newState = _this.updateColumns(_this.props);
                                newState.isLoadingGrid = false;
                                _this.setState(newState);
                                return false;
                            }
                        });
                    }
                };
                ReactGrid.prototype.componentWillUnmount = function () {
                    this.resourcesObserver && this.resourcesObserver.dispose();
                };
                ReactGrid.prototype.componentDidUpdate = function () {
                    this.props.PostRender();
                };
                // TODO: add shouldComponentUpdate method?
                ReactGrid.prototype.render = function () {
                    // This check is necessary because the Control Library is loaded async
                    if (this.state.isLoadingGrid) {
                        return null;
                    }
                    // Also pull off props from passThruProps that don't belong on ControlLibrary Grid or ListGrid
                    var _a = this.props, className = _a.ClassName, columnInfo = _a.ColumnInfo, collectionData = _a.CollectionData, defaultControl = _a.DefaultControl, forceNavigationAction = _a.ForceNavigationAction, navigationAction = _a.NavigationAction, navigationEnabled = _a.NavigationEnabled, setRef = _a.SetRef, markChange = _a.ToggleMark, markAllChange = _a.ToggleMarkAll, type = _a.Type, passThruProps = __rest(_a, ["ClassName", "ColumnInfo", "CollectionData", "DefaultControl", "ForceNavigationAction", "NavigationAction", "NavigationEnabled", "SetRef", "ToggleMark", "ToggleMarkAll", "Type"]);
                    if (this.props.Mode === $dyn.ui.ListMode.list) {
                        var cardHeight = void 0;
                        if (className === "helpPaneCardList") {
                            var currentDensity = $dyn.densityThemeManager._getCurrentDensity();
                            cardHeight = currentDensity * 4;
                        }
                        return (React.createElement(ControlLibrary.ListGrid, __assign({}, passThruProps, { ChildrenVersion: this.state.columnsVersion, className: className, CollectionData: this.state.isLoadingResources ? [] : collectionData, IsLoading: this.state.isLoadingResources, OnMarkAllRowsChange: markAllChange, OnRowMarkChange: markChange, ref: setRef }),
                            React.createElement(ControlLibrary.Card, { Actions: this.state.Actions, AlwaysShowActions: this.state.AlwaysShowActions, Height: cardHeight, HeightMode: cardHeight ? "Manual" /* Manual */ : "SizeToContent" /* ToContent */, Image: this.state.Image, Status: this.state.Status, Caption: this.state.Caption, Heading: this.state.Heading, Footer: this.state.Footer, Notes: this.state.Notes }, this.state.isLoadingResources ? null : this.state.columns)));
                    }
                    return (React.createElement(ControlLibrary.Grid, __assign({}, passThruProps, { ChildrenVersion: this.state.columnsVersion, className: className, CollectionData: this.state.isLoadingResources ? [] : collectionData, DebounceKeyDown: !$dyn.InsideTestWrapper, EnableAnimation: !$dyn.flags.disableAnimations, GridOptions: this.props.GetGridOptions ? this.props.GetGridOptions() : undefined, IsLoading: this.state.isLoadingResources, OnMarkAllRowsChange: markAllChange, OnRequestAddTotalColumn: this.onRequestAddTotalColumn, OnRowMarkChange: markChange, ref: setRef, ShowGroupMarking: true, ShowSyncingColumn: this.props.AllowEdit }), this.state.isLoadingResources ? null : this.state.columns));
                };
                ReactGrid.prototype.updateColumns = function (props) {
                    var columns = [];
                    var newState = {};
                    for (var i = 0; i < props.ColumnInfo.length; i++) {
                        var columnInfo = props.ColumnInfo[i];
                        if (columnInfo.ExtendedStyle === "Footer1") {
                            $dyn.setValue(columnInfo, "Width", "medium");
                        }
                        // Create column for control library grid from ax column
                        var columnControl = $dyn.reactGrid.generateColumn(columnInfo, props);
                        if (columnControl) {
                            if (props.Mode === $dyn.ui.ListMode.list) {
                                if (props.IsInSidePanel && i === 0 && columnInfo.TypeName !== "Image") {
                                    newState.Heading = columnControl;
                                }
                                else if (columnInfo.TypeName === "Image") {
                                    if (columnInfo.ExtendedStyle === "businessCard_notification") {
                                        newState.Status = columnControl;
                                    }
                                    else {
                                        newState.Image = columnControl;
                                    }
                                }
                                else if (columnInfo.TypeName === "Toolbar") {
                                    newState.Actions = columnControl;
                                    newState.AlwaysShowActions = false;
                                }
                                else if (columnInfo.TypeName === "MenuButton") {
                                    newState.Actions = columnControl;
                                    newState.AlwaysShowActions = true;
                                }
                                else if (columnInfo.ExtendedStyle === "Heading") {
                                    newState.Heading = columnControl;
                                }
                                else if (columnInfo.ExtendedStyle === "ImageCaption") {
                                    newState.Caption = columnControl;
                                }
                                else if (columnInfo.ExtendedStyle === "Footer1") {
                                    newState.Footer = columnControl;
                                }
                                else if (columnInfo.ExtendedStyle === "businessCard_notes") {
                                    newState.Notes = columnControl;
                                }
                                else if (props.Name === "AppListGrid" && columnInfo._name === "SysAppStore_Status") {
                                    newState.Notes = columnControl;
                                }
                                else if (props.Name === "AppListGrid" && columnInfo._name === "ColorPlaceholder") {
                                    // Don't add this control to this card, just using its display option as a background to the image
                                }
                                else {
                                    columns.push(columnControl);
                                }
                            }
                            else {
                                columns.push(columnControl);
                            }
                        }
                    }
                    if (props.Mode === $dyn.ui.ListMode.list && !newState.Heading && columns.length > 0) {
                        newState.Heading = columns[0];
                        columns.splice(0, 1);
                    }
                    newState.columns = columns;
                    newState.columnsVersion = this.state.columnsVersion + 1;
                    return newState;
                };
                return ReactGrid;
            }(React.Component));
            UI.ReactGrid = ReactGrid;
        })(UI = reactGrid.UI || (reactGrid.UI = {}));
    })(reactGrid = $dyn.reactGrid || ($dyn.reactGrid = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ReactGridUI.js.map
